import { IconAngleRight } from '@iwoca/icons';

import styles from './DocumentUploadSection.module.css';
import { TFile } from '../../../../../hooks/useFileUploadReducer';
import { TUploadRejectReasonCode } from '../../../UploadButton/UploadButton';
import DragDropUpload, {
  TDocumentType,
  TUploadResponse,
} from '../DragDropUpload/DragDropUpload';
import FileStatusSections from '../FileStatusSections/FileStatusSections';

type TProps = {
  documentType: TDocumentType;
  description?: string;
  listOfInstructions: React.ReactNode[];
  uploadedFiles: TFile[];
  isActive: boolean;
  isError?: boolean;
  onUpload?: (stateKey: string, body: FormData) => Promise<TUploadResponse>;
  setFileLoading: (id: string, name: string) => void;
  setFileSuccess: (id: string) => void;
  setFileError: (id: string, error: { code: string; detail: string }) => void;
  setFileReject: (id: string, rejectReason: TUploadRejectReasonCode) => void;
  removeFile: (id: string) => void;
  onRequestUpload?: () => void;
};

const DocumentUploadSection = ({
  documentType,
  description,
  listOfInstructions,
  uploadedFiles,
  isActive,
  isError,
  onUpload,
  setFileLoading,
  setFileSuccess,
  setFileError,
  setFileReject,
  removeFile,
  onRequestUpload,
}: TProps) => {
  const hasUploadedOrLoadingFiles = uploadedFiles.length > 0;

  return (
    <div className={styles.container}>
      {isActive && (
        <DragDropUpload
          documentType={documentType}
          description={description}
          listOfInstructions={listOfInstructions}
          isError={isError}
          onUpload={onUpload}
          setFileLoading={setFileLoading}
          setFileSuccess={setFileSuccess}
          setFileError={setFileError}
          setFileReject={setFileReject}
        />
      )}

      <FileStatusSections files={uploadedFiles} removeFile={removeFile} />

      {!isActive && hasUploadedOrLoadingFiles && onRequestUpload && (
        <button
          type="button"
          className={styles.uploadMoreButton}
          onClick={onRequestUpload}
        >
          Upload further documents
          <IconAngleRight className={styles.icon} />
        </button>
      )}
    </div>
  );
};

export default DocumentUploadSection;
